export default "__VITE_ASSET__afc66d31__"